/* eslint-disable */
import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import AppFormDialog from "components/common/AppFormDialog";
import Tooltip from "@mui/material/Tooltip";
import TextField from "@mui/material/TextField";

import IconButton from "@mui/material/IconButton";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import DeleteIcon from "@mui/icons-material/Delete";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import LocalMachineTable from "layouts/localDepositoDesechos/LocalMachineTable";

import localService from "services/localService";
import localDepositoTableData from "./data/localDepositoTableData";

import CreateLocalDepositoForm from "../../forms/local/localDepositoDesechos/createLocalDepositoForm";

import DeleteLocalMachinefromDepositoForm from "forms/localMachine/deleteLocalMachinefromDepositoForm";

import UpdateLocalForm from "../../forms/local/updateLocalForm";
import DeleteLocalForm from "../../forms/local/deleteLocalForm";
import MoveMachineBetweenDepositosForm from "forms/localMachine/moveMachineBetweenDepositosForm";

function LocalDeposito() {
  const location = useLocation();
  const [localsDetails, setLocalsDetails] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [query, setQuery] = useState("");
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  const [isDiscardModalOpen, setIsDiscardModalOpen] = useState(false);
  const [discardContext, setDiscardContext] = useState(null);

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [localToEdit, setLocalToEdit] = useState(null);
  const [localToDelete, setLocalToDelete] = useState(null);

  const [isMoveModalOpen, setIsMoveModalOpen] = useState(false);
  const [moveContext, setMoveContext] = useState(null);

  const navigate = useNavigate();

const load = useCallback(async () => {
    let cancelled = false;
    setIsLoading(true);

    try {
      const data = await localService.getActiveLocalDepositoMachines();
      if (cancelled) return;
      setLocalsDetails(data || []);
    } catch (e) {
      console.error("Error fetching depósitos:", e);
    } finally {
      if (!cancelled) setIsLoading(false);
    }

    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    load();
  }, [load, location.key]);

  useEffect(() => {
  const onFocus = () => load();
  const onVisibility = () => {
    if (document.visibilityState === "visible") load();
  };

  window.addEventListener("focus", onFocus);
  document.addEventListener("visibilitychange", onVisibility);

  return () => {
    window.removeEventListener("focus", onFocus);
    document.removeEventListener("visibilitychange", onVisibility);
  };
}, [load]);


  const handleOpenCreateModal = () => setIsCreateModalOpen(true);
  const handleCloseCreateModal = () => setIsCreateModalOpen(false);

  const handleOpenDiscardModal = (local, machine) => {
    setDiscardContext({ local, machine });
    setIsDiscardModalOpen(true);
  };

  const handleCloseDiscardModal = () => {
    setIsDiscardModalOpen(false);
    setDiscardContext(null);
  };

  const handleDiscardSuccess = async () => {
    await load();
    handleCloseDiscardModal();
  };

  const handleOpenEditModal = (localId) => {
    const local = localsDetails.find((l) => (l.Id ?? l.LocalId) === localId);
    if (!local) return;
    setLocalToEdit({
      Id: local.Id ?? local.LocalId,
      Name: local.Name,
      Address: local.Address,
      City: local.City,
      Department: local.Department,
    });
    setIsEditModalOpen(true);
  };

  const handleCloseEditModal = () => {
    setIsEditModalOpen(false);
    setLocalToEdit(null);
  };

  const handleOpenDeleteModal = (localId) => {
    const local = localsDetails.find((l) => (l.Id ?? l.LocalId) === localId);
    if (!local) return;
    setLocalToDelete({
      Id: local.Id ?? local.LocalId,
      Name: local.Name,
      Address: local.Address,
      City: local.City,
      Department: local.Department,
      CreatedAt: local.CreatedAt ?? null,
    });
    setIsDeleteModalOpen(true);
  };

  const handleCloseDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setLocalToDelete(null);
  };

  const handleDeleteSuccess = () => {
    handleCloseDeleteModal();
    load();
  };

  
  const handleOpenMoveModal = (local, machine) => {
    setMoveContext({ local, machine });
    setIsMoveModalOpen(true);
  };

  const handleCloseMoveModal = () => {
    setIsMoveModalOpen(false);
    setMoveContext(null);
  };

  const handleMoveSuccess = async () => {
    await load();
    handleCloseMoveModal();
  };

  const moveMachineLabel = moveContext
    ? [
        moveContext.machine?.MachineType?.Type,
        moveContext.machine?.Name || "sin nombre",
        moveContext.machine?.SerialNumber,
      ].filter(Boolean).join(" ")
    : "";

  const discardMachineLabel = discardContext
    ? [
        discardContext.machine?.MachineType?.Type,
        discardContext.machine?.Name || "sin nombre",
        discardContext.machine?.SerialNumber,
      ].filter(Boolean).join(" ")
    : "";

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDTypography variant="h6" color="white">
                  Depósitos
                </MDTypography>

                <MDBox display="flex" gap={1}>
                  <Button color="inherit" onClick={handleOpenCreateModal}>
                    Nuevo depósito
                  </Button>
                  <Button
                    color="inherit"
                    onClick={() => navigate("/localDesechos")}
                  >
                    Ver bajas
                  </Button>
                </MDBox>
              </MDBox>

              <MDBox pt={3} px={3} pb={2} display="flex" justifyContent="flex-end">
                <TextField
                  label="Buscar por máquina, serie, tipo"
                  value={query}
                  size="small"
                  onChange={(event) => setQuery(event.target.value)}
                  sx={{
                    width: { xs: "100%", sm: 340 },
                    maxWidth: "100%",
                    "& .MuiOutlinedInput-root": { backgroundColor: "#fff" },
                  }}
                />
              </MDBox>

              <MDBox px={2} pb={3}>
                {(localsDetails || []).map((local) => {
                  const hasActiveMachines = Array.isArray(local.Machines) && local.Machines.length > 0;

                  return (
                    <LocalMachineTable
                      key={local.Id}
                      local={local}
                      query={query}
                      isLoading={isLoading}
                      makeTable={(machines) =>
                        localDepositoTableData({
                          machines,
                          onDiscard: (machine) => handleOpenDiscardModal(local, machine),
                          onMove: (machine) => handleOpenMoveModal(local, machine),
                        })
                      }
                      actions={
                        <>
                          <IconButton
                            name="updateDeposito"
                            aria-label="editar depósito"
                            color="primary"
                            onClick={() => handleOpenEditModal(local.Id)}
                          >
                            <DriveFileRenameOutlineIcon />
                          </IconButton>

                          <Tooltip title={hasActiveMachines ? "Retirar las máquinas para cerrarlo" : "Cerrar depósito"}>
                            <span>
                              <IconButton
                                name="deleteDeposito"
                                aria-label="cerrar depósito"
                                color="secondary"
                                disabled={hasActiveMachines}
                                onClick={() => handleOpenDeleteModal(local.Id)}
                              >
                                <DeleteIcon />
                              </IconButton>
                            </span>
                          </Tooltip>
                        </>
                      }
                    />
                  );
                })}
              </MDBox>

              {moveContext && (
                <AppFormDialog
                  open={isMoveModalOpen}
                  onClose={handleCloseMoveModal}
                  title={`Mover máquina ${moveMachineLabel}`}
                  disableEnforceFocus
                >
                    <MoveMachineBetweenDepositosForm
                      closeForm={handleCloseMoveModal}
                      depositoLocal={moveContext.local}
                      machine={moveContext.machine}
                      depositos={localsDetails.filter((l) => l.Id !== moveContext.local.Id)}
                      onMoveSuccess={handleMoveSuccess}
                    />
                </AppFormDialog>
              )}


            </Card>
          </Grid>
        </Grid>
      </MDBox>

      <AppFormDialog open={isCreateModalOpen} onClose={handleCloseCreateModal} title="Nuevo depósito">
          <CreateLocalDepositoForm
          closeForm={handleCloseCreateModal}
          onCreated={load}
        />
      </AppFormDialog>

      {discardContext && (
        <AppFormDialog
          open={isDiscardModalOpen}
          onClose={handleCloseDiscardModal}
          title={`Dar de baja máquina ${discardMachineLabel}`}
          disableEnforceFocus
        >
            <DeleteLocalMachinefromDepositoForm
              closeForm={handleCloseDiscardModal}
              depositoLocal={discardContext.local}
              localMachine={discardContext.machine}
              onDeleteSuccess={handleDiscardSuccess}
            />
        </AppFormDialog>
      )}

      {localToEdit && (
        <AppFormDialog
          open={isEditModalOpen}
          onClose={handleCloseEditModal}
          title={localToEdit.Name ? `Editar depósito ${localToEdit.Name}` : "Editar depósito"}
          maxWidth="md"
        >
            <UpdateLocalForm
              closeForm={handleCloseEditModal}
               local={localToEdit}
               onSaved={load}
            />
        </AppFormDialog>
      )}

      {localToDelete && (
        <AppFormDialog
          open={isDeleteModalOpen}
          onClose={handleCloseDeleteModal}
          title={localToDelete.Name ? `Cerrar depósito ${localToDelete.Name}` : "Cerrar depósito"}
        >
            <DeleteLocalForm
              closeForm={handleCloseDeleteModal}
              local={localToDelete}
              onDelete={handleDeleteSuccess}
            />
        </AppFormDialog>
      )}

      <Footer />
    </DashboardLayout>
  );
}

export default LocalDeposito;
